import * as React from "react"
import Box from "@mui/material/Box"
import TabsWrappedLabel from "../../../../../components/tabs/tabs-component"
import PropTypes from "prop-types"

const EmissionTabsWrappedLabel = ({
    emissionTabChildren,
    memoriaCalculoTabChildren,
    documentsTabChildren,
    value,
    onChange,
}) => {
    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <TabsWrappedLabel
                value={value}
                onChange={onChange}
                tabs={[
                    {
                        value: "emission",
                        label: "EMISSÃO",
                        content: emissionTabChildren,
                    },
                    {
                        value: "memoriaCalculo",
                        label: "MEMÓRIA DE CÁLCULO",
                        content: memoriaCalculoTabChildren,
                    },
                    {
                        value: "documents",
                        label: "DOCUMENTOS",
                        content: documentsTabChildren,
                    }
                ]}
            />
        </Box>
    )
}

EmissionTabsWrappedLabel.propTypes = {
    emissionTabChildren: PropTypes.node,
    memoriaCalculoTabChildren: PropTypes.node,
    documentsTabChildren: PropTypes.node,
    value: PropTypes.string,
    onChange: PropTypes.func,
}

export default EmissionTabsWrappedLabel